import {useEffect} from 'react';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {collectTextNodes} from '../utils/domText';

const TOKEN = /\{\{[^{}]*\}\}/g;

/** Yellow token highlight via the CSS Custom Highlight API. The DOM is never changed, so nothing to strip on save. */
export default function TokenHighlightPlugin() {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (typeof CSS === 'undefined' || !CSS.highlights || !window.Highlight) return undefined;
    const HighlightCtor = window.Highlight;
    let raf = 0;
    const paint = () => {
      const root = editor.getRootElement();
      if (!root) return;
      const ranges = [];
      collectTextNodes(root).forEach((n) => {
        TOKEN.lastIndex = 0;
        let m;
        while ((m = TOKEN.exec(n.nodeValue))) {
          const r = document.createRange();
          r.setStart(n, m.index);
          r.setEnd(n, m.index + m[0].length);
          ranges.push(r);
        }
      });
      CSS.highlights.set('doc-token', new HighlightCtor(...ranges));
    };
    const schedule = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); };
    schedule();
    const off = editor.registerUpdateListener(schedule);
    return () => { off(); cancelAnimationFrame(raf); CSS.highlights.delete('doc-token'); };
  }, [editor]);
  return null;
}